module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_500_1000.137b5ebb.png";